import actionCreatorFactory, { isType } from 'typescript-fsa';

import * as api from '../api';
import * as logger from '../logger';
import * as store from './store';
import { Action } from 'redux';

const actionCreator = actionCreatorFactory();

export interface PatientDataPayload {
  authenticationCode: string;
}
export const setAuthenticationCode = actionCreator<PatientDataPayload>(
  'SET_AUTHENTICATION_CODE',
);
export function setAuthenticationCodeHandler(
  state: store.All,
  payload: PatientDataPayload,
): store.All {
  const { authenticationCode } = payload;
  return {
    ...state,
    authenticationCode,
  };
}

export const insuranceCardActionCreators = actionCreator.async<
  {},
  store.InsuranceCard[],
  string
>('FETCH_INSURANCE_CARDS');

export const makeFetchInsuranceCards =
  (dispatch: Function) =>
  async (previsitFormSetId: string): Promise<void> => {
    const params = {};
    dispatch(insuranceCardActionCreators.started(params));

    try {
      const result =
        await api.client.PrevisitPatientInsuranceInformation.findAllWithDetails(
          previsitFormSetId,
        );
      dispatch(insuranceCardActionCreators.done({ params, result }));
    } catch (err) {
      logger.error(err, 'ran into error attempting to fetch insurance cards:');
      return dispatch(
        insuranceCardActionCreators.failed({ error: err.msg, params }),
      );
    }
  };

export function fetchInsuranceCardsHandler(
  state: store.All,
  action: Action,
): store.All {
  if (isType(action, insuranceCardActionCreators.started)) {
    return {
      ...state,
      insuranceCards: {
        ...state.insuranceCards,
        loading: true,
        error: null,
      },
    };
  }

  if (isType(action, insuranceCardActionCreators.done)) {
    return {
      ...state,
      insuranceCards: {
        ...state.insuranceCards,
        data: action.payload.result,
        loading: false,
        updated: new Date(),
      },
    };
  }

  if (isType(action, insuranceCardActionCreators.failed)) {
    return {
      ...state,
      insuranceCards: {
        ...state.insuranceCards,
        loading: false,
        error: action.payload.error,
        updated: new Date(),
      },
    };
  }

  return state;
}

export const setCoordinates = actionCreator<api.Places.Geometry | undefined>(
  'SET_COORDINATES',
);
export function setCoordinatesHandler(
  state: store.All,
  coordinates?: api.Places.Geometry,
): store.All {
  return {
    ...state,
    coordinates,
  };
}

export const setEmbedded = actionCreator<boolean | null>('SET_EMBEDDED');
export function setEmbeddedHandler(
  state: store.All,
  embedded: boolean | null,
): store.All {
  return {
    ...state,
    embedded,
  };
}
